import clsx from "clsx"
import { FC, PropsWithChildren } from "react"
import styles from "./HowItWorksImg.module.scss"

interface IHowItWorksText extends PropsWithChildren {
  className?: string
  src: string
}

export const HowItWorksImg: FC<PropsWithChildren<IHowItWorksText>> = ({
  className,
  src
}) => {
  return (
    <div className={clsx(styles.HowItWorksImg, className)}>
      <img src={src} alt="tutorial" />
    </div>
  )
}
